import { Button, Popconfirm, Tag } from "antd";
import React from "react";
import { BiBook } from "react-icons/bi";
import { FiPackage } from "react-icons/fi";
import { IoMdGlobe } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import Container from "../General/Container/Container"
import { FormOutlined } from "@ant-design/icons";
import { setEditTarget } from "../../store/components/BuildTargets.slice";
import { setMode } from "../../store/components/Minified.slice";
import { useNavigate } from "react-router-dom";
import { needToConfirmTheResultWillRemoved } from "../../utils/confirmation/ConfirmationHelper";

const MinifiedHeader = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const {
        setup: {
            marketPackage,
            country
        }
    } = useSelector((state) => state.buildTargets);
    const { loadingResult, mode, loadingPersonasData, loadingPersonasImage
    } = useSelector((state) => state.minified);
    const showResult = mode === "result"

    const { confirm, confirmText } = needToConfirmTheResultWillRemoved()

    const renderActionButton = (type, text, disabled, onConfirm = () => { }) => {
        if (!confirm) return <Button type={type} onClick={onConfirm}>{text}</Button>
        return <Popconfirm
            placement="topRight"
            title={confirmText}
            onConfirm={onConfirm}
            okText="Yes"
            cancelText="No"
        >
            <Button type={type} disabled={disabled}>{text}</Button>
        </Popconfirm>
    }
    const isLoading = loadingResult || loadingPersonasData || loadingPersonasImage
    return <Container className={"minified-header drow align-center fullw " + (showResult ? "justify-between" : "justify-end")}>
        <Container className="minified-header-action1 drow align-center">
            <Tag className="minified-header-tag label" >Market Package:</Tag>
            <Tag className="minified-header-tag value" icon={<FiPackage />}>{marketPackage?.parent?.name || ""}</Tag>
            <Tag className="minified-header-tag value" icon={<BiBook />}>{marketPackage?.name || ""}</Tag>
            <Tag className="minified-header-tag value" icon={<IoMdGlobe />}>{country?.name || ""}</Tag>
            <Button type="link" onClick={() => {
                dispatch(setEditTarget(true));
            }}><FormOutlined /></Button>
        </Container>
        {showResult ? <Container className="minified-header-action2 drow align-center">
            {renderActionButton("link", "Advanced Analysis", isLoading, () => {
                window.sq.oneintel.isLoadedAnalysis = true;
                navigate("/advanced")
                setTimeout(() => {
                    window.sq.oneintel.isLoadedAnalysis = false;
                }, 1000);
            })}
            {renderActionButton("", "Start again?", isLoading, () => {
                dispatch(setMode("creation"))
            })}
        </Container> : null}

    </Container>
}

export default MinifiedHeader